import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
        workflows: [
			{ name: "Import Files from FTP 1", clips: [] },
			{ name: "Check Files on QC", clips: [] },
			{ name: "Share Files to Edit 3", clips: [] },
			{ name: "Share Files to Location London", clips: [] },
			{ name: "Share Files to Flow Cloud", clips: [] },
			{ name: "Distribute to Netflix", clips: [] },
			{ name: "Distribute to Customer Alpha", clips: [] },
			{ name: "Publish to Website A", clips: [] },
			{ name: "Publish to Website B", clips: [] }
		],
        loading: false
};

/*
const deviceLoadSuccess = (state, action) => {
    const devices = state.devices;
    
    if(action.devices.count) {
        const elements = action.devices.device.elements;
        for (let key in elements) {
            devices.push({ id: elements[key].getId(), name: elements[key].getOptions().get('label')});
        }
    }
    
    return updateObject( state, { loading: false, devices: devices } );
}
*/
const reducer = ( state = initialState, action) => {
    switch (action.type) {
        /*case actionTypes.DEVICE_LOAD_START:
            return updateObject(state, { loading: true });
        case actionTypes.DEVICE_LOAD_FAIL:
            return updateObject(state, { loading: false });
        case actionTypes.DEVICE_LOAD_SUCCESS:
            return deviceLoadSuccess(state, action);
        case actionTypes.DEVICE_SET_SEARCH:
            return updateObject(state, { searchDevices: action.devices });*/
        default: 
            return state;
    }
}

export default reducer;
